import React from 'react'
import { components } from 'react-select'

import Box from '../../Box'
import Flex from '../../Flex'
import { StyledCheckbox } from '../styled'

import { SelectOptionProps } from '../Select.types'

const Option: React.FC<SelectOptionProps> = (props) => {
  return (
    <components.Option {...props}>
      {props.isCheckboxType ? (
        <Flex alignItems='center'>
          <StyledCheckbox checked={props.isSelected} readOnly={true} />
          <Box as='label' cursor='pointer'>
            {props.label}
          </Box>
        </Flex>
      ) : (
        props.label
      )}
    </components.Option>
  )
}

export default Option
